export interface IProductSummaryResponse {
  ProductID: number;
  PeriodEndDate: Date;
  AvgBalance: number;
  EndBalance: number;
  CouponRate: number;
  NumberOfAccts: number;
}

export interface IProductCPSummaryItem extends IProductSummaryResponse {
  AverageLife: number;
}

export const emptyItemRow = (): IProductCPSummaryItem => {
  return {
    ProductID: null,
    PeriodEndDate: null,
    AvgBalance: null,
    CouponRate: null,
    EndBalance: null,
    NumberOfAccts: null,
    AverageLife: null
  };
};
